module.exports = __webpack_public_path__ + "img/brivideo-poster.47a8ded1.jpg";